<template>
  <section class="top_head">
    <div class="flex-row first">
      <div class="name">
        <AvatarImage :src="authStore.userAvatar" />

        <p>{{ authStore.userUsername }}</p>
      </div>


      <div class="time_counter_box">
        <div class="flex-row">
          <slot name="timer"></slot>
        </div>
      </div>
    </div>

    <div class="flex-row gameplay_steps">
      <RoundStepItem
        v-for="roundStep in roundStepList"
        :key="roundStep.id"
        :index="roundStep.index"
        :answered="roundStep.answered"
        :correct="roundStep.correct"
        :total-rounds="totalRounds"
      />
    </div>

    <div class="flex-row third">
      <p class="quest">
        {{ $_translations.value.page_game_question_pt1 }}
        <b>{{ currentRoundIndex + 1 }}</b>
        {{ $_translations.value.page_game_question_pt2 }}
        {{ totalRounds }}
      </p>

      <div class="points">
        <BaseImage src="/static/images/points_1.svg" alt="points" />

        <p>{{ correctPoints }} {{ $_translations.value.page_game_points }}</p>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import BaseImage from '@/components/image/BaseImage.vue';
import AvatarImage from '@/components/image/AvatarImage.vue';
import RoundStepItem from '@/views/game/components/item/RoundStepItem.vue';
import useAuthStore from '@/store/modules/auth.js';

const props = defineProps({
  roundStepList: {
    type: Array,
    default: () => [],
  },
  currentRoundIndex: {
    type: Number,
    default: 0,
  },
  correctPoints: {
    type: Number,
    default: 0,
  },
});

const authStore = useAuthStore();

const totalRounds = computed(() => props.roundStepList.length);
</script>
